import type { IGetAllTournaments } from '../../../types/home.d';

export const SESSION_TOURNAMENT_MAX_OVERS = 'tournamentMaxOvers';
export const SESSION_TOURNAMENT_MAX_OVERS_PER_BOWLER = 'tournamentMaxOversPerBowler';

/** Call when user opens a tournament so schedule match can read overs without another fetch. */
export function storeTournamentOversInSession(t: Pick<IGetAllTournaments, 'maxOvers' | 'maxOversPerBowler'>): void {
  sessionStorage.setItem(SESSION_TOURNAMENT_MAX_OVERS, String(t.maxOvers ?? ''));
  sessionStorage.setItem(SESSION_TOURNAMENT_MAX_OVERS_PER_BOWLER, String(t.maxOversPerBowler ?? ''));
}

/**
 * Match overs / max bowler overs for schedule form: session first, else tournament row from league list.
 */
export function getTournamentOversForSchedule(
  tournamentRow: Pick<IGetAllTournaments, 'maxOvers' | 'maxOversPerBowler'> | null | undefined,
): { matchOvers: string; maxOversPerBowler: string } {
  const sMo = sessionStorage.getItem(SESSION_TOURNAMENT_MAX_OVERS)?.trim() ?? '';
  const sMb = sessionStorage.getItem(SESSION_TOURNAMENT_MAX_OVERS_PER_BOWLER)?.trim() ?? '';
  const matchOvers =
    sMo !== ''
      ? sMo
      : tournamentRow?.maxOvers != null && Number.isFinite(Number(tournamentRow.maxOvers))
        ? String(tournamentRow.maxOvers)
        : '';
  const maxOversPerBowler =
    sMb !== ''
      ? sMb
      : tournamentRow?.maxOversPerBowler != null && Number.isFinite(Number(tournamentRow.maxOversPerBowler))
        ? String(tournamentRow.maxOversPerBowler)
        : '';
  return { matchOvers, maxOversPerBowler };
}
